import React from 'react';
import { CheckIcon } from 'lucide-react';
const records = ['12 months of sales history', 'Verified stock movement', 'Recorded business expenses'];
export function FinanceMock() {
  return <div className="w-full max-w-[330px] rounded-[12px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-783" data-mp="36ojk06r4v08a">
      <p className="text-[14px] font-semibold text-ink" data-id="element-784" data-mp="32men8z5e1nhf">Working capital check</p>
      <p className="mt-1 text-[12px] text-ink-muted" data-id="element-785" data-mp="2xomzmhbs0nj1">Shared only when you choose to</p>

      <div className="mt-5 flex items-center gap-4" data-id="element-786" data-mp="2soqugerceq1w">
        <svg viewBox="0 0 72 72" className="h-[68px] w-[68px]" aria-hidden="true" data-id="element-787" data-mp="2snyyv3xqwsbm">
          <circle cx="36" cy="36" r="30" fill="none" stroke="#EDEAE5" strokeWidth="9" data-id="element-788" data-mp="2nqpc5w1qqurh" />
          <circle cx="36" cy="36" r="30" fill="none" stroke="#1C8CDE" strokeWidth="9" strokeLinecap="round" strokeDasharray="188.5" strokeDashoffset="56" transform="rotate(-90 36 36)" data-id="element-789" data-mp="2jpn7v0syvsin" />
        </svg>
        <div data-id="element-790" data-mp="2lful6ec576su">
          <p className="text-[22px] font-semibold tracking-[-0.02em] text-ink" data-id="element-791" data-mp="2ljibl4majd3c">70%</p>
          <p className="text-[12px] text-ink-muted" data-id="element-792" data-mp="2qe5rif38az6b">records complete</p>
        </div>
      </div>

      <ul className="mt-5 space-y-2.5 border-t border-canvas-line pt-4" data-id="element-793" data-mp="2cik76l7xx3k8">
        {records.map(r => <li key={r} className="flex items-center gap-2 text-[13px] text-ink-muted" data-id="element-794" data-mp="2gk5hbyt3b3qq">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-brand-soft" data-id="element-795" data-mp="348f6napii9mm">
              <CheckIcon className="h-2.5 w-2.5 text-brand" aria-hidden="true" data-id="element-796" data-mp="395yjc66kaecg" />
            </span>
            {r}
          </li>)}
      </ul>
    </div>;
}